import graphqlClient from '@/graphql/graphql-client';
import { eqFromWhere, toListQueryVariables } from '@/graphql/list-query';
import type { ListQueryVariables } from '@/graphql/types';
import { useQuery } from '@tanstack/react-query';
import {
  TemplateVariablessDocument,
  type TemplateVariablessQuery,
  type TemplateVariablessQueryVariables,
} from '@/graphql/generated/graphql';

export type TemplateVariableRecord = NonNullable<
  NonNullable<TemplateVariablessQuery['getTemplateVariabless']>['items']
>[number];
export type GetTemplateVariablesResponse = TemplateVariablessQuery;

export const toTemplateVariablesVariables = (
  params?: ListQueryVariables<Record<string, unknown>> | null
): TemplateVariablessQueryVariables => {
  const { where, paging } = toListQueryVariables(params);
  return {
    templateId: eqFromWhere(where, 'TemplateId'),
    pageNo: paging.pageNo,
    pageSize: paging.pageSize,
  };
};

export const useGetTemplateVariables = (params?: ListQueryVariables<Record<string, unknown>>) => {
  const variables = toTemplateVariablesVariables(params);
  return useQuery({
    queryKey: ['template-variables', variables],
    queryFn: () => graphqlClient.request(TemplateVariablessDocument, variables),
  });
};

export const requestTemplateVariables = (
  params?: ListQueryVariables<Record<string, unknown>>
) => {
  const variables = toTemplateVariablesVariables(params);
  return graphqlClient.request(TemplateVariablessDocument, variables);
};

export const GET_TEMPLATE_VARIABLES_QUERY = TemplateVariablessDocument;
